import BaseError from "./BaseError";

export default class InternalServerError extends BaseError {
  constructor(data) {
    super(data);
    this.name = "InternalServerError";
  }
}
